import Form from "./CaseMessageForm/Form";
export { default as ApplicantCaseMessageForm } from "./CaseMessageForm/ApplicantCaseMessageForm";
export { default as SaksbehandlerCaseMessageForm } from "./CaseMessageForm/SaksbehandlerCaseMessageForm";

export default Form;
